import { getCommentingAPI } from '../api/Commenting';
import useHasFASCommenting from '../features/fas/hooks/useHasFASCommenting';
export default function useCommentingApi() {
  const isUngatedForFASCommenting = useHasFASCommenting();
  return getCommentingAPI({
    isUngatedForFASCommenting
  });
}